<template>
  <div style="width: 100%; height: 260px; position: relative"
       :style="{ backgroundColor: stepTypeConfig(step.type).color }">
    <!--Left buttons bar-->
    <div class="d-flex flex-column align-center justify-space-between pl-2"
         style="position: absolute; left: 0; top: 0; height: 100%">
      <div class="d-flex flex-column align-center ">
        <v-switch color="white"
                  class="my-2"
                  dense
                  hide-details
                  v-model="isStepActive" />
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn class="mb-2"
                   color="white"
                   icon
                   small
                   v-on="on">
              <v-icon>
                {{ stepTypeConfig(step.type).isAutomatic ? 'mdi-flash' : 'mdi-account' }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ stepTypeConfig(step.type).isAutomatic ? $t('general.automatic') : $t('general.manual') }}</span>
        </v-tooltip>

        <v-btn color="white"
               icon small>
          <v-icon>
            {{ stepTypeConfig(step.type).icon }}
          </v-icon>
        </v-btn>
      </div>
      <!--<v-btn class="mb-2" color="white" icon small>
        <v-icon>mdi-circle-slice-2</v-icon>
      </v-btn>-->
    </div>

    <v-btn color="white"
           icon
           small
           style="position: absolute; top: 10px; left: 50%"
           @click="showUpdateStepDialog(step.id)">
      <v-icon>mdi-cog</v-icon>
    </v-btn>

    <!--Right top step number-->
    <span class="white--text"
          style="font-size: 32px; position: absolute; right: 10px; top: 0">
      {{ step.order + 1 }}
    </span>

    <v-row class="mx-0">
      <v-col cols="11" class="pt-12" style="padding-left: 60px!important">
        <div class="pb-2">
          <span class="white--text font-weight-bold mr-3">
            Starts at:
          </span>
          <span class="white--text font-weight-light" style="font-size: 14px">
            <b>{{ stepStartDate }}</b>
          </span>
        </div>

        <!--<v-icon color="white">
          mdi-source-fork
        </v-icon>

        <div class="pt-2">
          <span class="font-weight-medium white&#45;&#45;text">
            IF
          </span>
          <span class="font-weight-light white&#45;&#45;text">
            reply contains "stop", "annoyed"
          </span>
          <span class="font-weight-medium white&#45;&#45;text">
            DO
          </span>
          <span class="font-weight-light white&#45;&#45;text">
            opt-out
          </span>
        </div>-->
      </v-col>

      <v-col cols="12" style="padding-left: 60px!important">
        <div>
          <span class="d-block font-weight-bold white--text">
            {{ $t('general.tipsForTheStep', { type: stepTypeConfig(step.type).name }) }}:
          </span>

          <p class="tips-paragraph mb-0 pr-3 white--text font-weight-light text-justify"
             style="max-height: 115px; overflow-y: auto">
            {{ step.observation || $t('general.withoutTips') }}
          </p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import notifications from '@/libs/notifications'
export default {
  computed: {
    isStepActive: {
      get () {
        return this.step.active
      },
      set (value) {
        this.active = value
        this.updateStep()
      }
    },
    stepStartDate () {
      const sequenceStartDate = this.$moment(this.sequenceFullStartDate)
      const { afterStepInitIn, timeUnits } = this.step.goToNextStepAfter
      const stepTimeInMinutes = this.setTimeInMinutes(afterStepInitIn, timeUnits)
      return sequenceStartDate
        .add(stepTimeInMinutes, 'minutes')
        .add(this.previousStepBeginningTimeInMinutes, 'minutes')
        .format('YYYY-MM-DD - h:mm:ss')
    }
  },
  data () {
    return {
      active: true,
      wasImageLoadedCorrectly: false
    }
  },
  methods: {
    checkProfileImageLoad (value) {
      this.wasImageLoadedCorrectly = value
    },
    setTimeInMinutes (timeToTransform, timeUnits) {
      let timeToMinutesConverter = 1
      const time = parseInt(timeToTransform)
      if (timeUnits === 'days') {
        timeToMinutesConverter = 1440
      } else if (timeUnits === 'hours') {
        timeToMinutesConverter = 60
      }
      return time * timeToMinutesConverter
    },
    showUpdateStepDialog (stepId) {
      this.$emit('showUpdateStepDialog', stepId)
    },
    stepTypeConfig (stepType) {
      switch (stepType) {
        case 'call':
          return { name: this.$t('general.call'), icon: 'mdi-phone', color: '#2DCE98', isAutomatic: false }
        case 'email':
          return { name: this.$t('general.email'), icon: 'mdi-email-outline', color: '#F53C56', isAutomatic: true }
        case 'mEmail':
          return { name: this.$t('general.manualEmail'), icon: 'mdi-email-outline', color: '#F53C56', isAutomatic: false }
        case 'sms':
          return { name: this.$t('general.sms'), icon: 'mdi-message-processing', color: '#FB6340', isAutomatic: true }
        case 'social':
          return { name: this.$t('general.social'), icon: 'mdi-linkedin', color: '#4279D6', isAutomatic: false }
        case 'task':
          return { name: this.$t('general.task'), icon: 'mdi-calendar-check', color: '#7764E4', isAutomatic: false }
        default:
          return { name: stepType, icon: 'mdi-email-outline', color: '#F53C56', isAutomatic: false }
      }
    },
    async updateStep () {
      try {
        let { active } = this.step
        active = this.active
        await this.$store.dispatch('updateSequenceStep', {
          appId: this.$store.getters.appUuid,
          sequenceId: this.$route.params.sequenceId,
          stepId: this.step.id,
          data: { active }
        })
      } catch (e) {
        notifications.error(e)
      }
    }
  },
  props: {
    previousStepBeginningTimeInMinutes: {
      type: Number,
      default: 0
    },
    step: {
      type: Object,
      default: () => {}
    },
    sequenceFullStartDate: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
  p.tips-paragraph::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)!important;
    background-color: #f5f5f5!important;
  }
  p.tips-paragraph::-webkit-scrollbar {
    width: 6px!important;
    background-color: #f5f5f5!important;
  }
  p.tips-paragraph::-webkit-scrollbar-thumb {
    background-color: #4d4f5c!important;
  }
</style>
